export class DropdownOption {
  id: number;
  option: string;
  active_class: string;
  option_class: string;
  extra_params: any;
}
